import BuildIcon from '@mui/icons-material/Build';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import HistoryIcon from '@mui/icons-material/History';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import { Box } from '@mui/material';
import { EnhancedTabs, TabItem } from 'components/enhanced/tabs/EnhancedTabs';
import { useIsTenantAdministrator } from 'shared/permissions/IsTenantAdministrator';
import { IContractEquipment } from 'features/inventory/contracts/types';
import { IEquipment } from 'features/inventory/equipments/types';
import Maintenance from 'features/inventory/maintenance/views/Maintenance';
import { useEffect, useMemo, useState } from 'react';
import { contractEquipmentService } from 'shared/services';
import { ActivityTab } from './activity/EquipmentActivity';
import { BaseInfoCard } from './cards/BaseInfoCard';
import { MaintenanceCard } from './cards/MaintenanceCard';
import { DailyEquipmentChecklistsTab } from './check-list/DailyEquipmentChecklistsTabVersion2';
import { TicketsTab } from './tickets/Tickets';
import { EquipmentLogBookTimeline } from './unified-view/EquipmentLogBookTimeline';
import { Spinner } from 'components/ui/data-display';
interface LogBookProps {
  equipment: IEquipment | null;
}

export const LogBook = ({ equipment }: LogBookProps) => {
  const [activeContractEquipment, setActiveContractEquipment] = useState<IContractEquipment>(null);
  const isAdmin = useIsTenantAdministrator();

  useEffect(() => {
    if (!equipment?.id) return;
    contractEquipmentService
      .getAllBaseInformation({ equipment_id: equipment?.id, active: true })
      .then((res) => {
        setActiveContractEquipment(res ? res[0] : null);
      });
  }, [equipment?.id]);

  const tabs: TabItem[] = useMemo(
    () => [
      {
        label: 'Ticket',
        icon: <ConfirmationNumberIcon />,
        component: <TicketsTab equipment={equipment} />
      },
      {
        label: 'Manutenzione Preventiva',
        icon: <BuildIcon />,
        component: (
          <Maintenance
            isTabView={true}
            equipment={equipment}
            activeContrantEquipment={activeContractEquipment}
          />
        )
      },
      {
        label: 'Registro Attività',
        icon: <HistoryIcon />,
        component: <ActivityTab equipment={equipment} />
      },
      {
        label: 'Check List',
        icon: <CheckCircleIcon />,
        component: <DailyEquipmentChecklistsTab equipment={equipment} />
      },
      {
        label: 'Vista Unificata',
        visible: isAdmin,
        variant: 'admin',
        icon: <PendingActionsIcon />,
        component: <EquipmentLogBookTimeline equipmentId={equipment?.id} />
      }
    ],
    [equipment, activeContractEquipment]
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 3, pt: 3 }}>
        <BaseInfoCard equipment={equipment} />

        <MaintenanceCard activeContractEquipment={activeContractEquipment} Spinner={Spinner} />
      </Box>

      <EnhancedTabs
        tabs={tabs}
        variant="fullWidth"
        prefixId="logbook-view"
        containerProps={{
          sx: {
            borderRadius: '10px',
            backgroundColor: '#ffffff',
            overflow: 'hidden',
            boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.04)'
          }
        }}
      />
    </Box>
  );
};
